module.exports = __webpack_public_path__ + "img/border_clear.2f200549.svg";